import { useCallback, useContext, useMemo, useState } from 'react';

import { useAccessToken } from '../auth/use-access-token';

import { AlertContext } from '../contexts/alert-context';
import { storeLayout } from '../router';
import { StripeService } from '../services/stripe';

export const useManageBilling = () => {
  const { addErrorAlert } = useContext(AlertContext);
  const { store } = storeLayout.useRouteContext();
  const [loadingBilling, setLoadingBilling] = useState(false);
  const getAccessTokenSilently = useAccessToken();

  const stripeService = useMemo(
    () => new StripeService(getAccessTokenSilently),
    [getAccessTokenSilently]
  );

  const showBilling = useCallback(() => {
    setLoadingBilling(true);
    stripeService
      .createPortalSession(store.id)
      .then((response) => {
        window.location.replace(response.portal_url);
      })
      .catch((error: unknown) => {
        addErrorAlert('Could not open Stripe billing portal', { cause: error });
      })
      .finally(() => {
        setLoadingBilling(false);
      });
  }, [stripeService, addErrorAlert, store]);

  return { showBilling, loadingBilling };
};
